<template>
  <div class="UserStateReports">
    <h1 class="text-center my-7">گزارش تعداد کاربران استان {{ state }}</h1>
    <v-row>
      <v-col cols="12" md="3">
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="search"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="data"
              :search="search"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9">
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="480"
          :options="options"
          :series="series"
        />
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn
          outlined
          depressed
          color="primary"
          router
          :to="{
            name: 'UsersReport'
          }"
        >
          بازگشت
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "user-state-reports-component",
  data() {
    return {
      loading: false,
      search: "",
      state: "",
      headers: [
        { text: "استان", value: "name", align: "center" },
        { text: "تعداد شرکت کننده", value: "count", align: "center" }
      ],
      data: [],
      series: [
        {
          name: "تعداد شرکت کننده",
          data: []
        }
      ],
      options: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "تعداد شرکت کنندگان",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        stroke: {
          curve: "straight"
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          type: "gradient",
          gradient: {
            colorStops: [
              {
                offset: 0,
                color: "#3CD1A2",
                opacity: 1
              },
              {
                offset: 100,
                color: "#FF5670",
                opacity: 1
              }
            ]
          }
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 85,
            maxHeight: 150
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10
        }
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const apiUrl = "user/reportCityByState/" + this.$route.params.id;
      this.$api.get(apiUrl).then((res) => {
        this.state = res.data.state.name;
        const data = res.data.count;
        data.forEach((element) => {
          this.series[0].data.push(element.count);
          this.options.xaxis.categories.push(element.name);
        });
        this.data = data;
        this.loading = false;
      });
    }
  }
};
</script>
<style>
.UserStateReports .apexcharts-xaxis-texts-g {
  transform: translate(0, 50px);
}
.UserStateReports .apexcharts-yaxis {
  transform: translate(-97%, 0);
}
@media only screen and (max-width: 600px) {
  .UserStateReports .apexcharts-xaxis-texts-g {
    transform: translate(0, 50px);
  }
}
</style>
